import React from "react"

import AshinShah from "../../gatsby-images/ashin-shah";
import AtikShah from "../../gatsby-images/atik-shah";
import KiranShah from "../../gatsby-images/kiran-shah";
import ManishJain from "../../gatsby-images/manish-jain";
import PallavBhatt from "../../gatsby-images/pallav-bhatt";
import AboutUsTeamPhoto from "../../gatsby-images/about-us-team-photo";

import Rainmatter from "../../gatsby-images/rainmatter";
import Enam from "../../gatsby-images/enam";
import Gruhas from "../../gatsby-images/gruhas";
import Auxano from "../../gatsby-images/auxano";
import Samarthya from "../../gatsby-images/samarthya";

import styles from "./index.module.css";
import TryForFree from "../tryForFree";
import Metrics from "../../shared/metrics";
import GreenCurve from "../../gatsby-images/green-curve";
import { Link } from "gatsby";
import RainmatterWide from "../../gatsby-images/rainmatterWide";
import Zerodha from "../../gatsby-images/zerodha";

const TeamImages = {
  AshinShah: <AshinShah/>,
  AtikShah: <AtikShah/>,
  KiranShah: <KiranShah/>,
  ManishJain: <ManishJain/>,
  PallavBhatt: <PallavBhatt/>
}

const InvestorsImages = {
  Rainmatter: <Rainmatter/>,
  Enam: <Enam/>,
  Gruhas: <Gruhas/>,
  Auxano: <Auxano/>,
  Samarthya: <Samarthya/>
}

const About = ({aboutContent}) => (
    <div className={styles.about_main_section}>
        <div className={styles.mpr_title_section}>
          <div className={styles.backgroundCurve}>
            <GreenCurve/>
          </div>
            <div className="container">
                <div className="row justify-content-md-center">
                    <div className={[styles.mpr_main_title ,'col-lg-8','text-md-left','text-center'].join(' ')}>
                      <h2 className="mb-3">{aboutContent.mission.headline}</h2>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <div className={[styles.mpr_intro ,'col-lg-8'].join(' ')}>
                      {
                        aboutContent.mission.paragraphs.map((para,index) => (
                          <p key={index} className="text-center mb-0">{para}</p>
                        ))
                      }
                    </div>
                </div>
            </div>
        </div>
        <div className={styles.about_banner_section}>
          <div className="container">
            {/* <div className="row justify-content-center mb-5">
              <div className="col-10 col-lg-8 text-center">
                <HomeTopGraphic/>
              </div>
            </div> */}
            <div className="row">
              <Metrics/>
            </div>
          </div>
        </div>
        <div className={styles.our_story_section}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 p-0 pl-md-3 pr-md-5">
                {/* <img src={our_story_img} alt="Our story" /> */}
                <AboutUsTeamPhoto/>
              </div>
              <div className="col-md-6 pt-5 pb-5 pt-md-0 pb-md-0">
                <div className={styles.mpr_title}>
                  <h2 className="mb-3 text-md-left text-center">{aboutContent.story.headline}</h2>
                </div>
                {
                  aboutContent.story.paragraphs.map((para,index) => (
                    <p key={index} className={["text-md-left text-center",styles.ourStoryText].join(' ')}>{para}</p>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        <div className={styles.our_team_section}>
          <div className="container">
            <div className="row justify-content-md-center">
              <div className={[styles.mpr_title ,'text-center','col','pb-3','pb-md-5'].join(' ')}>
                <h2>{aboutContent.team.headline}</h2>
              </div>
            </div>
            <div className="row">
              {
                aboutContent.team.list.sort((x,y) => x.order < y.order ? -1 : 1)
                  .map((member,index) => 
                    <TeamItem member={member} key={member.order}/>
                  )
              }
            </div>
          </div>
        </div>
        <div className={styles.investorsSection}>
          <div className="container">
            <div className="row justify-content-md-center">
              <div className={[styles.mpr_title ,'text-center','col'].join(' ')}>
                <h2>{aboutContent.investors.headline}</h2>
              </div>
            </div>
            <a className={styles.rainmatterRow} href="https://rainmatter.com/" target="_blank">
              <div className={styles.rainmatterContainer}>
                <div className={styles.rainmatterLogoContainer}>
                  <RainmatterWide/>
                </div>
                <div className={styles.rainmatterInitiativeContainer}>
                  <div className={styles.rainmatterInitiativeText}>an initiative by</div>
                  <div className={styles.zerodhaLogoContainer}>
                    <Zerodha/>
                  </div>
                </div>
              </div>
            </a>
            <div className={[styles.investorsRow,"row"].join(' ')}>
              {
                aboutContent.investors.list.sort((x,y) => x.order < y.order ? -1 : 1)
                  .map((investor,index) => 
                    <InvestorsItem investor={investor} key={investor.order}/>
                  )
              }
            </div>
          </div>
        </div>
        <TryForFree/>
      </div>
)

const TeamItem = ({member}) => {
  return (
    <div className={[styles.our_team_box,'col-md col-12 ml-auto mr-auto','mt-md-4','mb-4'].join(' ')}>
        {/* <img className="mb-2 w-100" src={team_img2} alt={member.name}/> */}
        {
          TeamImages[member.image]
        }
        <h5 className="mt-3">{member.name}</h5>
        <h6>{member.designation}</h6>
        <Link className={styles.readBio} to="/leadership" state={{activeLeader: member.order}}>Read Bio</Link>
    </div>
  )
}

const InvestorsItem = ({investor}) => {
  return (
    <div className={[styles.investorBox,'col-md-4 col-12 ml-auto mr-auto','mt-md-4','mb-4'].join(' ')}>
        <a className={styles.investorImage} href={investor.link} target="_blank">
        {
          InvestorsImages[investor.image]
        }
        </a>
        {/* <h5 className={[styles.investorName].join(' ')}>{investor.name}</h5> */}
    </div>
  )
}

export default About
